<template src="./Cart.html"/>
<style lang="scss" scoped src="./Cart.scss"/>
<script>
import {
  SfCollectedProduct,
  SfButton,
  SfCircleIcon,
  SfImage,
  SfPrice,
  SfProperty,
  SfHeading,
  SfBreadcrumbs,
  SfInput,
  SfIcon,
  SfLink,
  SfTextarea,
  SfCheckbox
} from '@storefront-ui/vue';
import OrderSummary from '@/components/Cart/OrderSummary.vue';
import Api from "@/api/Api";
import icons from "@/utils/icons";
import OrkPrice from "@/components/Ork/OrkPrice";
import GtagEvent from "@/utils/GtagEvent";


export default {
  name: 'Cart',
  components: {
    SfLink,
    OrkPrice,
    SfIcon,
    SfCheckbox,
    SfInput,
    SfPrice,
    SfCircleIcon,
    SfCollectedProduct,
    SfBreadcrumbs,
    SfImage,
    SfButton,
    SfHeading,
    SfTextarea,
    SfProperty,
    OrderSummary
  },

  data() {
    return {
      totals: {
        amount: 0,
        total: 0,
        subtotal: 0
      },
      showMessage: process.env.VUE_APP_SHOWMESSAGE === 'true',
      gift: null,
      icons: icons,
      loading: true,
      error: null,
      coupon: null,
      message: '',
      giftCardReference: process.env.VUE_APP_GIFTCARD_REF === 'true',
      breadcrumbs: [
        {
          text: this.$i18n.t('Home'),
          link: '/'
        },
        {
          text: this.$i18n.t('Your cart'),
          link: ''
        }
      ]
    };
  },
  computed: {
    currentCart: {
      get() {
        return this.$store.getters.getCart
      },
    },
  },
  created() {
    let offersId = JSON.parse(sessionStorage.getItem('NoStockItems'))
    if (offersId) {
      offersId.forEach((id) => {
        this.currentCart.cartItems.map((item) => {
          if (item.product.offer.id === id) {
            item.noStock = true;
          }
        });
      });
    }
    if (this.currentCart) {
      GtagEvent.viewCart(this.currentCart)
    }
  },
  watch: {
    currentCart(newCart) {
      let offersId = JSON.parse(sessionStorage.getItem('NoStockItems'))
      if (offersId) {
        offersId.forEach((id) => {
          newCart.cartItems.map((item) => {
            if (item.product.offer.id === id) {
              item.noStock = true;
            }
          });
        });
        this.currentCart = newCart;
      }
    }
  },
  methods: {
    goBack() {
      return this.$router.go(-1);
    },

    clearCart() {
      Api.cart.emptyCart(this.currentCart.id).then((data) => {
        this.$store.dispatch('setCart', data)
      }).catch((e) => {
        this.$store.dispatch('setCart', null);
        this.currentCart = null;
      })
    },

    setCoupon() {
      if (this.coupon) {
        Api.cart.addCoupon(this.coupon).then((data) => {
          this.$store.dispatch('setCart', data);
          this.$store.dispatch('sendNotification', {
            type: 'info',
            message: this.$i18n.t('coupon.add'),
            icon: icons.info
          });
        })
            .catch((e) => {
              switch (e.status) {
                case 409:
                  this.$store.dispatch('sendNotification', {
                    type: 'danger',
                    message: this.$i18n.t('coupon.add'),
                    icon: icons.error
                  });
                  break;
                case 404:
                  this.$store.dispatch('sendNotification', {
                    type: 'danger',
                    message: this.$i18n.t('coupon.not'),
                    icon: icons.error
                  });
                  break;
                case 499:

                  break;
                default:
                  this.$store.dispatch('sendNotification', {
                    type: 'danger',
                    message: this.$i18n.t('errors.server.access'),
                    icon: icons.error
                  });
                  break
              }

            })
            .finally();
      }
    },
    addGiftWrap(offerId) {


    },
    setOfferQuantity(params) {
      this.loading = true;

      let cart = params.currentCart,
          itemIsInCart = null,
          qty = params.quantity,
          prevQty = 0,
          stock = 0;

      if (cart && cart.cartItems && cart.cartItems.length) {
        itemIsInCart = cart.cartItems.find(item => item.product?.offer?.id === params.offerId);

        if (itemIsInCart) {
          prevQty = itemIsInCart?.quantity || 0;
          stock = itemIsInCart?.product.offer.stockQuantity || 0;
        }
      }


      if (qty > stock) {
        this.$store.dispatch('sendNotification', {
          type: 'info',
          message: this.$i18n.t("addToCart.max"),
          icon: icons.info
        });
        params.quantity = stock;
        Api.cart.setOfferQuantity(params)
            .then(data => {
              this.$store.dispatch('setCart', data);
            });
      } else {
        Api.cart.setOfferQuantity(params)
            .then(data => {
              this.$store.dispatch('setCart', data);
              let message = '';
              switch (params.method) {
                case'add':
                  GtagEvent.AddToCartShipment(params.product, qty, this.currentCart)
                  message = this.$i18n.t("addToCart.add");
                  break;
                case'remove':
                  GtagEvent.RemoveToCart(params.product, this.currentCart)
                  message = this.$i18n.t('addToCart.remove');
                  break;
                case 'update':
                  GtagEvent.AddToCartShipment(params.product, qty, this.currentCart)
                  message = this.$i18n.t('addToCart.update');
                  break;
              }
              this.$store.dispatch('sendNotification', {
                type: 'info',
                message: message,
                icon: icons.info

              });
            })
            .catch((e) => {
              console.error(e)
              /* this.$store.dispatch('setCart', null);
               this.currentCart = null;*/
              if (e.status !== 499) {
                this.$store.dispatch('sendNotification', {
                  type: 'danger',
                  message: this.$i18n.t('errors.server.access'),
                  icon: icons.error
                });
                this.error = e;
              }
            })
            .finally(this.loading = false);
      }
    }
  }
};
</script>

